import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { SellingCompanyWarehouse } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class SellingCompanyWarehouseService extends TmsWebBaseEditCreateService<
  SellingCompanyWarehouse,
  SellingCompanyWarehouse
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('SellingCompanyWarehouse', $localize`Selling Company Warehouse`);
  }

  getForSellingCompany(id: string): Observable<SellingCompanyWarehouse[]> {
    return this.httpService.get<SellingCompanyWarehouse[]>(`${this.apiUrl}/GetForSellingCompany?id=${id}`);
  }
}
